module.exports = __webpack_public_path__ + "img/direction-left.62157c1c.svg";